import LanguageSelector from 'components/language-selector';
import { useIsExistingCustomer } from 'hooks/common/use-is-existing-customer';
import useNavigationData from 'hooks/navigation/use-navigation-data';
import Link from 'next/link';
import React from 'react';
import { Gtm } from 'tracking';
import { isAbsoluteUrl } from 'utils/url/url';
import UspBar from '../usp-bar';

/**
 * Header Top
 */
const HeaderTop: React.ComponentType = () => {
  const { header } = useNavigationData();
  const { isEc, loading } = useIsExistingCustomer();
  const showUspBar = !loading && !isEc;

  return (
    <div className="bg-grey-100 w-full">
      <div className="container">
        {/* Trustbar for desktop */}
        <div className="hidden h-8 items-center text-center text-sm leading-none lg:flex">
          <div className="grid w-full grid-cols-[1fr_auto_1fr] items-center">
            {showUspBar && (
              <div
                data-test="promo-banner2"
                className="col-start-2 flex min-w-0 items-center justify-center overflow-hidden"
              >
                <UspBar variant="embedded-top" />
              </div>
            )}
            <div className="col-start-3 flex shrink-0 items-center justify-end gap-2.5 whitespace-nowrap">
              {header.items.map((item) => {
                return (
                  <React.Fragment key={item.title}>
                    {item.items.map((item) => {
                      if (item && isAbsoluteUrl(item.url)) {
                        return (
                          <a
                            key={item.url}
                            data-test={`desktop-trustbar-${item.title}`}
                            href={item.url}
                            target={'_blank'}
                            className="pt-pxleading-none text-primary-main ml-4 flex cursor-pointer justify-end"
                            rel="noreferrer"
                          >
                            <span className="hover:underline">{item.title}</span>
                          </a>
                        );
                      } else {
                        return (
                          <Link
                            data-test={`desktop-trustbar-${item.title}`}
                            key={item.url}
                            href={item.url}
                            className="pt-pxleading-none text-primary-main ml-4 flex cursor-pointer justify-end"
                            onClick={() => {
                              if (item.track) {
                                Gtm.track({
                                  group: Gtm.Group.Component,
                                  name: Gtm.ComponentEvent.Click,
                                  data: { label: item.track },
                                });
                              }
                            }}
                          >
                            <span className="hover:underline">{item.title}</span>
                          </Link>
                        );
                      }
                    })}
                  </React.Fragment>
                );
              })}
              <div
                className="bg-grey-300 h-4 w-px rounded-sm"
                data-test="language-selector-divider"
              />
              <LanguageSelector />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderTop;
